import badgeBronze from "assets/images/bronze_badge.png";
import badgeGolden from "assets/images/golden_badge.png";
import badgePlatinum from "assets/images/platinum.png";
import badgeSilver from "assets/images/silver_badge.png";

const exports = {
  tierBadges: [badgeBronze, badgeSilver, badgeGolden, badgePlatinum],
};

export default exports;
